module.exports = __webpack_public_path__ + "static/media/fontext_3.80b679c5.ico";